<h1 mat-dialog-title>{{data.outcome}}</h1>

<div mat-dialog-content>
    <!-- Loading State -->
    <div *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{'comment.loading' | translate}}</p>
    </div>

    <!-- Content when not loading -->
    <div *ngIf="!isLoading" class="loading-container">
        <mat-form-field
                *ngIf="hasRejectionReasons"
                fxFlex="100%"
                appearance="outline"
                class="full-width-field">
            <mat-label>{{'comment.selectReason' | translate}}</mat-label>
            <mat-select
                    [formControl]="reasonControl"
                    required
                    #reasonSelect>
                <mat-option>
                    <ngx-mat-select-search
                            [formControl]="reasonFilterCtrl"
                            placeholderLabel="{{'invoiceProcessing.search' | translate}}"
                            noEntriesFoundLabel="{{'invoiceProcessing.noResults' | translate}}">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option
                        *ngFor="let reason of filteredReasons | async"
                        [value]="reason">
                    {{reason}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="reasonControl.hasError('required')">
                {{'comment.reasonRequired' | translate}}
            </mat-error>
        </mat-form-field>

        <mat-form-field
                *ngIf="showCustomInput || !hasRejectionReasons"
                fxFlex="100%"
                appearance="outline"
                class="full-width-field"
                [class.mt-3]="hasRejectionReasons">
            <mat-label>
                {{hasRejectionReasons ? ('comment.specifyOther' | translate) : ('comment.message' | translate)}}
            </mat-label>
            <textarea
                    matInput
                    [formControl]="customMessageControl"
                    rows="4"
                    [placeholder]="hasRejectionReasons ? ('comment.specifyOtherPlaceholder' | translate) : ('comment.messagePlaceholder' | translate)"
                    required>
      </textarea>
            <mat-error *ngIf="customMessageControl.hasError('required')">
                {{'comment.messageRequired' | translate}}
            </mat-error>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button
            mat-button
            color="primary"
            (click)="onNoClick()"
            [disabled]="isLoading">
        {{'comment.cancel' | translate}}
    </button>
    <button
            mat-button
            color="primary"
            (click)="handleActionConfirm()"
            [disabled]="!isFormValid()">
        {{'comment.confirm' | translate}}
    </button>
</div>

<style>
    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        min-height: 150px;
    }

    .loading-container p {
        margin-top: 1rem;
        color: rgba(0, 0, 0, 0.54);
    }

    .full-width-field {
        width: 100%;
    }

    .mt-3 {
        margin-top: 1rem;
    }
</style>